import React from 'react';
export default function QuestionHeader(props) {

const { surveyScreenData, surveyLanguageName, handleLanguage, langList, questionsList, answerCount, CurrQuesIndex } = props;

let [scrollPosition, HandlescrollPosition] = React.useState(0)

let lastKnownScrollPosition = 0
document.addEventListener('scroll', () =>{
    lastKnownScrollPosition = window.scrollY;
    HandlescrollPosition(lastKnownScrollPosition)
});



let [showDrop, openLangModal ] = React.useState(false);

console.log("langList----->",langList)


  let QuestionIndex = questionsList && questionsList.length>0? questionsList.findIndex(prev=>prev.id===CurrQuesIndex)+1 :0

  return (
<>

{/* <header className="bg-white w-full z-10 fixed top-0" style={{position: '-webkit-sticky', top: 0}}>
  <div className=" md:px-6 px-4   mx-auto flex justify-between py-2">
    <img src="img/novotel.png" className="w-36" />
   
    <div className="flex text-sm font-medium  items-center relative cursor-pointer"> <p>English</p> <span className="material-icons">arrow_drop_down</span>
      
      <div className="absolute top-12 right-0 bg-white text-xs w-24 py-2 shadow-lg rounded-sm text-gray-700 hidden">
        <span className="block px-4 py-1 hover:bg-gray-100">German</span>
        <span className="block px-4 py-1 hover:bg-gray-100">Arbic</span>
        <span className="block px-4 py-1 hover:bg-gray-100">Hindi</span>
      </div>
    </div>
  </div>
  <div className="h-1 w-full bg-white "><div className="h-1 w-6/12 bg-green-400 " /> </div>
</header> */}






<header className="w-full h-12 bg-white fixed top-0" style={{position: '-webkit-sticky', top: 0, zIndex:1}}>
  <div className=" md:px-6 px-4   mx-auto flex justify-between py-2 bg-white">
  {(surveyScreenData && surveyScreenData.logo) ? 
    <img src={surveyScreenData.logo } className="h-12" />
    : null
  }  
    
    <div className="flex text-sm font-medium  items-center relative cursor-pointer"> 

    <p 
    style={{color:'black'}}
    className='font-bold'
    onClick={() => openLangModal(!showDrop)}>{surveyLanguageName}</p> 
    <span 
    style={{color:'black'}}
    onClick={() => openLangModal(!showDrop)} className="material-icons">arrow_drop_down</span>
    
    {showDrop ?
      <div className="absolute top-12 right-0 bg-white text-xs w-24 py-2 shadow-lg rounded-sm text-gray-700">
      {langList && langList.length > 0 ?
      langList.map((item,index) =>
        <span 
        onClick={() => {
          handleLanguage(item)
          openLangModal(!showDrop)
        }} 
        key={index}
        style={{color:'black'}}
        className="block px-4 py-1 hover:bg-gray-100 ">{item.name}</span>
        ): null}
      </div>
      : null}


    </div>
  </div>


  {/* <div className="h-1 w-full bg-white "><div className="h-1 w-6/12 bg-green-400 " 
  style={{width:(questionsList && questionsList.length>0?parseInt(answerCount*100/questionsList.length).toString():"0")+"%"}}
  /> </div> */}

<div className="h-1 w-full bg-white "><div className="h-1 w-6/12 bg-green-400 " 
  style={{width:(questionsList && questionsList.length>0?parseInt(QuestionIndex*100/questionsList.length).toString():"0")+"%"}}
  /> </div>


  
</header>





</>
  );}